import React from 'react';
import './FormStyles.css';

export default function PhoneInput({
  label,
  name,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  className = '',
}) {
  const handlePhoneChange = (e) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 10);
    onChange({ ...e, target: { ...e.target, name, value: val } });
  };

  // Format for display
  const formatPhone = (val) => {
    if (!val) return '';
    const cleaned = val.replace(/\D/g, '');
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 6) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  };

  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label htmlFor={name} className="form-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <input
        id={name}
        type="tel"
        name={name}
        value={formatPhone(value)}
        onChange={handlePhoneChange}
        disabled={disabled}
        placeholder="10-digit phone number"
        className={`form-input ${error ? 'error' : ''}`}
        maxLength="12"
      />
      <small className="form-help">10-digit Indian phone number</small>
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}
